//防抖
export const debounce = (fn, delay = 100) =>{   //默认100毫秒
  let timer;
  return function() {
    let args = arguments;
    if(timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

/** 日期加上天数得到新的日期 */
//dateTemp 需要参加计算的日期，days要添加的天数，返回新的日期，日期格式：YYYY-MM-DD
export function getNewDay(dateTemp, days) {
  var dateTemp = dateTemp.split("-");
//转换为MM-DD-YYYY格式
  var nDate = new Date(dateTemp[1] + '/' + dateTemp[2] + '/' + dateTemp[0]); 
  var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);
  var rDate = new Date(millSeconds);
  var year = rDate.getFullYear();
  var month = rDate.getMonth() + 1;
  if (month < 10) month = "0" + month;
  var date = rDate.getDate();
  if (date < 10) date = "0" + date;
  return (year + "-" + month + "-" + date);
}